import {State, useAppDispatch, useAppSelector} from "../../app/Store";
import {useEffect} from "react";
import {ChainId, ethereum, web3} from "../../app/Config";
import "./MintBlock.css";
import {MintingState, MintSelectors, setCount, setMax, setMin, setPrice, setState} from "../../slices/MintSlice";
import {ConnectSelectors} from "../../slices/ConnectSlice";
import {Connector} from "./Connector";
import {getContract} from "../../app/Contract";

interface Params {
	connect?: boolean
}

export function MintBlock({connect = false}: Params) {

	const dispatch = useAppDispatch();

	const isConnected = useAppSelector(ConnectSelectors.isConnected);
	const {address, chainId} = useAppSelector(ConnectSelectors.userData);
	const isLogin = isConnected && chainId === ChainId;

	const state = useAppSelector(MintSelectors.state);
	const price = useAppSelector(MintSelectors.price);
	const count = useAppSelector(MintSelectors.count);
	const min = useAppSelector(MintSelectors.min);
	const max = useAppSelector(MintSelectors.max);

	const enable = state == MintingState.WhiteList ||
		state == MintingState.PublicScale;
	const label = enable ? "MINT NOW" : "MINT NOT START";

	async function init() {
		const contract = await getContract();
		const wei = await contract.methods.Price().call();
		const max = await contract.methods.MaxMint().call();
		const stage = await contract.methods.stage().call();

		const ether = Number(web3.utils.fromWei(wei));

		dispatch(setPrice(ether))
		dispatch(setMin(1))
		dispatch(setMax(max))
		dispatch(setState(Number(stage)))
		// dispatch(setState(MintingState.PublicScale))
	}
	useEffect(() => {init().then()}, []);

	function onInput(e: any) {
		dispatch(setCount(Number(e.target.value)));
		console.log(count);
		// e.target.value = count.toString()
	}
	function onBlur(e: any) {
		e.target.value = count.toString()
	}
	async function mint() {
		if (!enable) return;
		console.log("Mint:", count);

		const contract = await getContract();
		const value = web3.utils.toWei(String(count * price));
		contract.methods.mint(count).send({
			from: address, value
		});
	}

	return (!connect && !isLogin) || state == MintingState.Hidden ?
		<div className="discord button">
			<div className="label">JOIN THE DISCORD</div>
			<div className="effect"/>
			<img src={require("../../assets/button-frame1-small.png")}/>
		</div> :
		<div className="mint-block">
			<img className="frame lt" src={require("../../assets/frame-lt.png")}/>
			<img className="frame lb" src={require("../../assets/frame-lb.png")}/>
			<img className="frame rt" src={require("../../assets/frame-rt.png")}/>
			<img className="frame rb" src={require("../../assets/frame-rb.png")}/>
			<div className="mint-content">
				<div className="mint-price">
					MINT PRICE
					<div className="price">
						<img src={require("../../assets/ether.png")}/>{price}
					</div>
				</div>
				<input className="count" name="count" type="number"
							 defaultValue={1} onBlur={onBlur}
							 onInput={onInput} max={max} min={min}/>
				<div className="tips">Total Price {count * price} ETH</div>
				{
					!connect || isLogin ?
						<div className={enable ? "mint button" : "mint button disable"} onClick={mint}>
							<div className="label">{label}</div>
							<div className="effect"/>
							<img src={require("../../assets/button-frame1-small.png")}/>
						</div> : <Connector/>
				}
			</div>
		</div>
}
